import React from 'react';

import {
  activityTemplates,
  layout,
  SingleOrderRecordNavigator,
  widgets
} from 'modules';
import {
  useLocation,
  useParams
} from 'react-router-dom';

import * as CustomerOrderActionsWidget from './CustomerOrderActionsWidget/CustomerOrderActionsWidget';
import * as ChatWidget from './ChatWidget/ChatWidget';
import * as LineItemsWidget from './LineItemsWidget/LineItemsWidget';
import * as SummaryInformationWidget from './SummaryInformationWidget/SummaryInformationWidget';



export const OrderDetailActivity: React.FC = () => {
  const location = useLocation();
  const params = useParams<{ orderId: string; }>();
  const orderId = params.orderId ?? '';
  const [selectedRecordId, setSelectedRecordId] = React.useState(orderId);



  const storeId = React.useMemo(
    () => {
      const search = new URLSearchParams(location.search);
      return search.get('storeId') ?? '';
    },
    [location.search]
  );

  return !orderId ? null : (
    <activityTemplates.CustomerActivityTemplate.FC storeId={storeId}>
      <layout.ColumnBox>
        <SingleOrderRecordNavigator.FC
          orderId={orderId}
          selectedRecordId={selectedRecordId}
          onSelectRecord={setSelectedRecordId} />

        {selectedRecordId === orderId ? (
          <layout.ColumnBox>
            <layout.RowBox>
              <layout.ColumnBox>
                <CustomerOrderActionsWidget.FC orderId={orderId} />
                <SummaryInformationWidget.FC orderId={orderId} />

                <layout.RowBox>
                  <widgets.order.ShippingInformationWidget.FC orderId={orderId} />
                  {/* Map */}
                  <widgets.order.PaymentInformationWidget.FC orderId={orderId} />{/* Putting payment info widget here for now */}
                </layout.RowBox>
              </layout.ColumnBox>
              <widgets.order.FulfillmentStatusWidget.CustomerFC orderId={orderId} />
            </layout.RowBox>

            <layout.RowBox>
              {/* Payment information */}
              <LineItemsWidget.FC orderId={orderId} />
            </layout.RowBox>

            <ChatWidget.FC orderId={orderId} />
          </layout.ColumnBox>

        ) : (

          <layout.ColumnBox>
            <layout.RowBox>
              <layout.ColumnBox>
                <layout.RowBox>
                  <widgets.returnAuthorization.SummaryWidget.FC
                    returnAuthorizationId={selectedRecordId}
                    variant="customer" />

                  <widgets.returnAuthorization.CustomerReturnShippingWidget.FC
                    returnAuthorizationId={selectedRecordId} />

                </layout.RowBox>

                <widgets.returnAuthorization.ReturnedProductsWidget.FC
                  returnAuthorizationId={selectedRecordId}
                  variant="customer" />
              </layout.ColumnBox>

              <widgets.returnAuthorization.LifeCycleWidget.FC
                variant="customer"
                storeId={storeId}
                returnAuthorizationId={selectedRecordId} />
            </layout.RowBox>

            <ChatWidget.FC returnAuthorizationId={selectedRecordId} />
          </layout.ColumnBox>
        )}

      </layout.ColumnBox>
    </activityTemplates.CustomerActivityTemplate.FC>
  );
};
